/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {
    FETCH_COLLECTION_NOTES_SUCCESS,
    SAVE_COLLECTION_NOTES_SUCCESS
} from '../_actions/collection.notes.action';

export const INITIAL_STATE = {
    collectionNotes : [
        {
            body : '',
            collection: null,
            collectionNoteHolds: [{
                hold: '',
                selected : false,
                collectionDto : null,
            }],
            created : null,
            createdTimestamp: null,
            messageType: null,
            user: null,
            userFirstName: null,
            userLastName: null

        }
    ],
    holds : []
};

export function collectionNotesReducer(state = INITIAL_STATE,action){
    switch (action.type){
        case FETCH_COLLECTION_NOTES_SUCCESS: {
            return {collectionNotes : action.payload.collectionNotes,
                holds : action.payload.collectionNotes.holds
            };
        }
        case SAVE_COLLECTION_NOTES_SUCCESS: {
            return {collectionNotes : action.payload.collectionNotes,
                holds : action.payload.collectionNotes.holds
            };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/collection.notes.reducer.js